import {css} from '@yandex-delivery/blocks/theme/css'
import {theme} from '@yandex-delivery/blocks/theme/theme'
import {makeStyles} from '@yandex-delivery/blocks/theme/UNSTABLE_makeStyles'

const size = theme.spacing(43)
const classes = {
  root: css`
    width: ${size}px;
    right: ${theme.spacing(2)}px;
    left: auto;
    top: 300px;
    margin-top: 24px;

    [dir='rtl'] & {
      left: ${theme.spacing(2)}px;
      right: auto;
    }
  `,
  buttonRoot: css`
    padding: ${theme.spacing(1)}px;
  `,
  postcard: css`
    display: flex;
    flex-direction: column;
    height: ${size}px;
    border-radius: ${theme.spacing(3)}px;
    overflow: hidden;
    position: relative;
    padding: ${theme.spacing(2)}px;
    color: ${theme.go.schemes.colors.system.BgMain};
    background: center / cover no-repeat;
  `,
  postcardTitle: css`
    position: relative;
    z-index: 20;
    color: ${theme.go.schemes.colors.system.BgMain};
    width: 75%;
  `,
  postcardFooter: css`
    position: relative;
    z-index: 20;
    display: flex;
    margin-top: auto;
  `,
  summary: css`
    margin-left: auto !important;
    color: ${theme.go.schemes.colors.system.BgMain};
    padding: ${theme.spacing(1)}px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: ${theme.spacing(1.5)}px;

    [dir='rtl'] & {
      margin-right: auto;
      margin-left: 0 !important;
    }
  `,
}

export type ClassKey = keyof typeof classes

export const useClasses = makeStyles(classes)
